module.exports = __webpack_public_path__ + "static/media/Heart_Attack_Signs_Symptoms_226016HD.b1fe8d59.mp4";